var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div id=\"docSelect\" class=\"dropdown\" title=\"Select Document\">\n    <span class=\"ddValue\">"
    + container.escapeExpression(((helper = (helper = helpers.initialValue || (depth0 != null ? depth0.initialValue : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"initialValue","hash":{},"data":data}) : helper)))
    + "</span>\n    <span class=\"select-icon icon-arrow-combo\"></span>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/docSelect/select.hbs
 ** module id = 698
 ** module chunks = 0
 **/